// src/components/elements/Logo.js
import React from 'react';

const STRAPI_BASE_URL = process.env.REACT_APP_STRAPI_BASE_URL;

const Logo = ({ Logo, Description, TextColorHexCode }) => {
console.log('Logo Tectcolor:', TextColorHexCode);
  const titleStyle = {
    color: TextColorHexCode || 'inherit', // Standardfarbe, falls kein Hex-Code gesetzt
  };

  if (!Logo || !Logo.data || !Logo.data.attributes) {
    return null; // Kein Logo-Bild vorhanden
  }

  const imageUrl = `${STRAPI_BASE_URL}${Logo.data.attributes.url}`;
  const altText = Logo.data.attributes.alternativeText || Description || 'Logo';

  return (
    <div className="logo-container text-center" style={titleStyle}>
      <img src={imageUrl} alt={altText} style={{ maxHeight: '48px', width: 'auto' }} className="img-fluid" />
      {Description && <p className="small mt-1">{Description}</p>}
    </div>
  );
};

export default Logo;
